import { constrain } from 'js/helpers/math';

export function scrollOpen(
  container: React.RefObject<HTMLElement | null>,
  contentContainer: React.RefObject<HTMLElement | null>
): void {
  if (!container.current || !contentContainer.current) {
    return;
  }

  // fixed position browse search header
  const searchHeader: HTMLDivElement | null = document.querySelector(
    '.header-search-placeholder'
  );
  const searchHeaderHeight = searchHeader ? searchHeader.offsetHeight : 0;

  // add extra spacing above and below
  const scrollPadding = 16;

  const maxScrollYOffset = Math.max(
    0,
    container.current.getBoundingClientRect().top -
      scrollPadding -
      searchHeaderHeight
  );
  const scrollByY = constrain(
    contentContainer.current.getBoundingClientRect().bottom +
      scrollPadding -
      window.innerHeight,
    0,
    maxScrollYOffset
  );

  if (scrollByY !== 0) {
    window.scrollBy({
      left: 0,
      top: scrollByY,
      behavior: 'smooth',
    });
  }
}
